import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';

const customerLogos = [
  {
    name: 'Joseph Joseph',
    src: '/images/customer-logos/joseph-joseph.png',
    href: 'https://www.josephjoseph.com/',
    width: 326,
    height: 140,
    className: styles.josephCustomerLogo
  },
  {
    name: 'IHG Hotels & Resorts',
    src: '/images/customer-logos/ihg.svg',
    href: 'https://www.ihg.com/',
    width: 190,
    height: 32,
    className: styles.ihgCustomerLogo
  },
  {
    name: 'Infosys',
    src: '/images/customer-logos/infosys.png',
    href: 'https://www.infosys.com/',
    width: 120,
    height: 48,
    className: styles.infosysCustomerLogo
  },
  {
    name: 'Check Point',
    src: '/images/customer-logos/check-point.png',
    href: 'https://www.checkpoint.com/',
    width: 155,
    height: 60,
    className: styles.checkPointCustomerLogo
  },
  {
    name: 'Marriott',
    src: '/images/customer-logos/marriott.png',
    href: 'https://www.marriott.com/',
    width: 84,
    height: 63,
    className: styles.marriottCustomerLogo
  }
];

export const CustomerProof = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.customerProof} aria-labelledby='customer-proof-title'>
      <div className={styles.proofInner}>
        <p id='customer-proof-title'>{t('homepage.customerProof.title')}</p>
        <div className={styles.customerLogos}>
          {customerLogos.map((logo) => (
            <span className={styles.customerLogo} key={logo.name}>
              <a
                className={styles.customerLogoLink}
                href={logo.href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={t('homepage.customerProof.websiteLabel', { name: logo.name })}
              >
                <Image
                  className={logo.className}
                  src={logo.src}
                  alt={logo.name}
                  width={logo.width}
                  height={logo.height}
                />
              </a>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
